import BackgroundWrapper        from "_components/atoms/backgroundWrapper";
import Typography               from "_components/atoms/typography";
import ChannelAnalyticsOverview from "_components/features/creatorDashboard/organisms/channelAnalyticsOverview";
import ContentOverview          from "_components/features/creatorDashboard/organisms/contentOverview";
import DataMigrationModal       from "_components/features/creatorDashboard/organisms/dataMigrationModal";
import EarningOverview          from "_components/features/creatorDashboard/organisms/earningOverview";
import FAQOverview              from "_components/features/creatorDashboard/organisms/faqOverview";

import useStyles from "./styles";

const Overview = ( { latestContent, intialMonetisationData, isMobile, isMigratingData = false } ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<BackgroundWrapper
			className = { classes.overviewRoot }
			type      = "secondary"
		>
			<Typography
				className = { classes.heading }
				title     = { "Channel Overview" }
			/>

			<div className = { isMobile ? classes.overviewFlex : classes.overviewGrid }>

				<div className = { classes.channelAnalytics }>
					<ChannelAnalyticsOverview isMigratingData = { isMigratingData }
						isMobile                                 = { isMobile }
					/>
				</div>

				<div className = { classes.content }>
					<ContentOverview
						isMobile      = { isMobile }
						latestContent = { latestContent }
					/>

				</div>

				<div className = { classes.earning }>
					<EarningOverview
						intialMonetisationData = { intialMonetisationData }
						isMigratingData        = { isMigratingData }
						isMobile               = { isMobile }
					/>

				</div>

				<div className = { classes.faq }>
					<FAQOverview isMobile = { isMobile } />
				</div>
			</div>

			<DataMigrationModal isMigratingData = { isMigratingData }
				isMobile                           = { isMobile }
			/>
		</BackgroundWrapper>
	);
};

export default Overview;
